import {BaseMuWidget} from "./BaseMuWidget";
import {CommonCL} from "./generated/CommonCL";
import {MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {UiTomSelect} from "./components/UiTomSelect";
import {TicketsCL} from "./generated/TicketsCL";

export class UiTicketRels extends BaseMuWidget {
	public profile: TicketRelProfile = { type: 3, direction: null };

	public cl: TicketsCL = new TicketsCL();

	public ticketId: number;

	public projectId: number|null = null;

	public buSubjectId: number|null = null;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		ticketSelector: UiTomSelect
	}>;

	beforeIndex() {
		this.muAppendContent(`
			<div class="display-flex">
				<div mu-widget="UiTomSelect" mu-id="ticketSelector" class="flex-grow-1">
					<div mu-widget="." mu-template="item">
						<strong mu-bind="evidenceUid"></strong> <span mu-bind="summary"></span>
					</div>
				</div>
				<span class="icon-before-add btn-icon btn-icon-size-3" mu-id="bAdd">Připojit související</span>			
			</div>
			<table class="table">
				<thead><tr><th>Ev. číslo</th><th>Název</th><th>Stav</th></tr></thead>
				<tbody mu-id="items" mu-bind="items:@foreach">
					<tr mu-template="item" mu-widget="UiTicketRelsItem" mu-bind="id:.id;ticketRelId:.ticketRelId">
						<td><span mu-id="evidenceUid" class="a" mu-bind="evidenceUid"></span></td>
						<td><span mu-id="summary" class="a" mu-bind="summary"></span></td>
						<td><span mu-bind="stateName"></span></td>

						<td>
							<span class="icon-before-remove" mu-id="bRemove"></span>
						</td>
					</tr>
				</tbody>
			</table>
			<p mu-id="noItems">Žádné související požadavky</p>
		`)
	}

	async afterIndex() {

		this.muNamedWidget.ticketSelector.init({
			optionLoader: async(q, resolv) => resolv(await this.cl.findTickets(
				q,
				{
					projectId: this.projectId,
					buSubjectId: this.buSubjectId
						? (Array.isArray(this.buSubjectId) ? this.buSubjectId : [this.buSubjectId])
						: null,
				}
			), []),
			valueField: 'id',
			searchField: [ 'summary', 'evidenceUid' ],
			multiple: true,
		});

		this.reloadList();
	}

	async bAdd_click() {
		this.reloadList(
			await this.cl.addTicketRels(
				this.ticketId,
				this.profile,
				this.muNamedWidget.ticketSelector.muFetchData(),
				true
			)
		);
		this.muNamedWidget.ticketSelector.muBindData([]);
	}

	async reloadList(items: any = null) {
		if (items === null) items = await this.cl.getTicketRels(this.ticketId, this.profile);
		this.muBindData({ items: items });
		this.muVisible(!!items, ['items', '!noItems'])
	}
}

export class UiTicketRelsItem extends BaseMuWidget
{
	// @ts-ignore
	muParent: UiTicketRels;

	// @ts-ignore
	id: number;

	// @ts-ignore
	ticketRelId: number;

	afterIndex() {

	}

	async bRemove_click() {
		if (confirm('Odebrat související požadavek?')) {
			await this.muParent.cl.withMessage("Odebírám související požadavek").dropTicketRels(this.ticketRelId);
			this.muParent.reloadList();
		}
	}

	evidenceUid_click() { this.doLoadTicket(this.id); }
	summary_click() { this.doLoadTicket(this.id); }

	private doLoadTicket(id: number) {
		this.callMethodInFirstAncestors('loadTicket', id);
	}
}

export type TicketRelProfile = {
	type: number;
	direction: number|null;
};